// extracted by mini-css-extract-plugin
export var orderDetails = "_uj-2";
export var orderImage = "_uj-1";
export var orderMeta = "_uj-3";
export var orderSummary = "_uj-0";
export var rightArrow = "_uj-4";